


export class PublicationsTopView {

    constructor() {

        this.id = 'top-publications';
		
		this.box = document.getElementById(this.id);
		if (!this.box) {
			
			//throw new Error('#' + id + ' element missing');
			return false;
		}
		
		//заголовок
		this.title = this.box.querySelector('.sc_title > strong');
		
		//контейнер для элементов
		this.ul = this.box.querySelector('.ul');
		
		//шаблоны для возможного последующего добавления:
		this.itemTemplate = this.ul.querySelector('.li')?.cloneNode(true);
    }

    render(state) { 

        if (!this.box) { return false;}
		
		//для смены текста заголовка
		if (state.title) { this.title.textContent = state.title;}
		
		//замена скелетонов-шаблонов на подгруженные данные (с подчисткой оставшихся "пустышек", если подгрузка была меньше)
		if (state.data) {
			
			const dummies = this.ul.querySelectorAll('.dummy');
			dummies.forEach((el, index) => {
				
				const data = state.data[index];

				//если данных больше нет, удаляем лишний .li со скелетоном
				if (!data) {
					el.parentElement.remove();
					return;
				}
				
				//id:
				el.dataset.id = data.id;
				
				//url для ссылок
				const titleLink = el.querySelector('.title > a');
				titleLink.href = data.url;
				
				//заголовок
				titleLink.textContent = data.title;
				
				//дата
				el.querySelector('.date').textContent = data.date;

				//снимаем класс скелетона
				el.classList.remove('dummy');
			});

			//удаляем пустые .li (если пришедших данных было меньше изначального кол-ва скелетонов)
			this.ul.querySelectorAll('.li').forEach((li) => {
				if (!li.textContent.trim() && li.children.length === 0) { li.remove();}
			});
			
			//пустой блок не должен отображаться:
			this.box.style.display = (this.ul.querySelector('.li')) ? '' : 'none';
			
			this.box.classList.remove('dummy');
		}
    }
}